
import { AssessmentAnswers } from '@/types/assessment';

interface Question {
  id: number;
  question: string;
  responses: string[];
  category: string;
  conditionalOn?: number;
  conditionalResponse?: string;
}

export const useAssessmentValidation = () => {
  // Vérifier si toutes les questions obligatoires d'une catégorie sont répondues
  const validateCategoryAnswers = (
    questions: Question[],
    answers: AssessmentAnswers,
    allQuestions: Question[] = []
  ): boolean => {
    if (!questions || questions.length === 0) return false;

    return questions.every((question) => {
      // Si c'est une question conditionnelle, vérifier si elle doit être affichée
      if (question.conditionalOn && question.conditionalResponse) {
        const parentAnswer = answers[question.conditionalOn];
        if (parentAnswer !== question.conditionalResponse) {
          // Cette question ne doit pas être affichée, donc pas besoin de réponse
          return true;
        }
      }

      // Vérifier si la question a une réponse
      const answer = answers[question.id];
      
      // Pour les questions à réponse libre
      if (question.responses.includes("Réponse libre")) {
        return answer && typeof answer === 'string' && answer.trim().length > 0;
      }
      
      // Pour les autres questions
      return answer !== undefined && answer !== null && answer !== '';
    });
  };

  // Vérifier les informations de contact
  const validateContactInfo = (contactInfo: any): boolean => {
    return !!(
      contactInfo.firstName?.trim() &&
      contactInfo.lastName?.trim() &&
      contactInfo.function?.trim() &&
      contactInfo.company?.trim() &&
      contactInfo.email?.trim() &&
      contactInfo.phone?.trim() &&
      contactInfo.rgpdConsent
    );
  };

  // Vérifier si une question doit être affichée (logique conditionnelle)
  const shouldShowQuestion = (
    question: Question,
    answers: AssessmentAnswers
  ): boolean => {
    if (!question.conditionalOn || !question.conditionalResponse) {
      return true;
    }

    const parentAnswer = answers[question.conditionalOn];
    return parentAnswer === question.conditionalResponse;
  };

  // Filtrer les questions à afficher en fonction des réponses conditionnelles
  const getVisibleQuestions = (
    questions: Question[],
    answers: AssessmentAnswers
  ): Question[] => {
    return questions.filter(question => shouldShowQuestion(question, answers));
  };

  return {
    validateCategoryAnswers,
    validateContactInfo,
    shouldShowQuestion,
    getVisibleQuestions
  };
};
